webpackJsonp([132900821841348],{

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookAuth = __webpack_require__(34);
	
	var _LoreHookAuth2 = _interopRequireDefault(_LoreHookAuth);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookAuth2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'get'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'get'
	      ),
	      ' action...'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      /* eslint consistent-return: "off" */\n\n      import { ActionTypes, PayloadStates, normalize, payload } from \'lore-utils\';\n\n      /*\n       * Blueprint for Get method\n       */\n\n      export default function(modelName, models, lore) {\n        const Model = models[modelName];\n\n        return function get() {\n          return function(dispatch) {\n            const model = new Model();\n\n            model.fetch().then(function() {\n              // look through the model and generate actions for any attributes with\n              // nested data that should be normalized\n              const actions = normalize(lore, modelName).model(model);\n\n              dispatch({\n                type: ActionTypes.update(modelName),\n                payload: payload(model, PayloadStates.RESOLVED)\n              });\n\n              // dispatch any actions created from normalizing nested data\n              actions.forEach(dispatch);\n            }).catch(function(response) {\n              const error = response.data;\n\n              dispatch({\n                type: ActionTypes.update(modelName),\n                payload: payload(model, PayloadStates.ERROR_FETCHING, error)\n              });\n            });\n\n            return dispatch({\n              type: ActionTypes.add(modelName),\n              payload: payload(model, PayloadStates.FETCHING)\n            });\n          };\n        };\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-auth-actions-get-js-d5e4fe9879567785d7b7.js